import { substringWithoutSpace } from '../helpers/common';

export const adsBelowCta = catName => ({
  name: `Desktop_${substringWithoutSpace(catName)}_VAP_1`,
  width: 300,
  height: 250
});

export const adsBelowSD = catName => [
  {
    name: `Desktop_${substringWithoutSpace(catName)}_VAP_2_1`,
    width: 300,
    height: 250
  },
  {
    name: `Desktop_${substringWithoutSpace(catName)}_VAP_2_2`,
    width: 300,
    height: 250
  }
];

export const msiteAdsBelowDesc = catName => ({
  name: `mSite_${substringWithoutSpace(catName)}_VAP_1`,
  width: 320,
  height: 100
});

export const msiteAdsBelowSD = catName => ({
  name: `mSite_${substringWithoutSpace(catName)}_VAP_2`,
  width: 300,
  height: 250
});

export const msiteInterstitial = {
  name: 'mSite_Interstitial_1',
  width: 320,
  height: 480
};
